import React, { useEffect, useState } from "react";
import ConfirmForm from "./ConfirmForm";
import OnScrollAnimationWrapper from "../common/OnScrollAnimationWrapper";

function ConfirmationContainer({ t }) {
  const [guests, setGuests] = useState(0);

  useEffect(() => { }, [guests]);

  return (
    <section
      className="confirmation-container bg-border p-top-8 p-bottom-8"
      id="confirm"
    >
      <div className="container">
        <OnScrollAnimationWrapper
          animation={"animation-slide-fade-in-down"}
          triggerOnce={false}
          classNameInitialState={`opacity-0 text-animation-slide-in`}
        >
          <h2 className="text-white text-center font-body letter-spacing-4px">{t.confirmTitle}</h2>
        </OnScrollAnimationWrapper>
        <div className="flex flex-align-center flex-justify-center gap-1 hearth-separator m-top-0"><div className="heart-separator-line bg-third"></div><i className="fa-solid fa-heart text-third text-xs"></i><div className="heart-separator-line bg-third"></div></div>
        <div className="text-white text-center m-top-2 m-bottom-4 text-lg">
          {/* {t.confirmTextLead}<span style={{ borderBottom: "2px dotted white" }}>{" "}{t.deadline}</span> */}
        </div>
        <ConfirmForm t={t} />
        <h4 className="text-white text-center m-top-4 m-bottom-4 font-body">
          {t.confirmAnother}
        </h4>

        {guests > 0 &&
          [...Array(guests)].map((item, index) => {
            return (
              <div key={index} className="m-top-3 m-bottom-3">
                <ConfirmForm t={t} />
              </div>
            );
          })}

        <div className="m-top-4 m-bottom-2 text-center">
          <button
            className="confirm-btn confirm-btn-inverse"
            onClick={() => setGuests(guests + 1)}
          >
            {t.addGuest}
          </button>
        </div>
      </div>
    </section>
  );
}

export default ConfirmationContainer;
